module.exports = __webpack_public_path__ + "static/media/stankinInfoXL.1161b44a.png";